import classNames from "classnames";
import {
    HTTP_INTERNAL_SERVER_ERROR,
    HTTP_NOT_FOUND,
    HTTP_HTTP_VERSION_NOT_SUPPORTED,
    HTTP_GATEWAY_TIMEOUT,
} from "../../constants/http";
import { PAGE_COMPONENT_UNIVERSAL_CLASS_NAME } from "../../constants/page";

type ErrorPageProps = {
    statusCode?: number;
    polopolyId?: string;
};
/**
 * The ErrorPage component.
 *
 * This page will be displayed if the app throws server errors like the 500 codes
 * @param {object} props - The component properties
 * @returns {React.Component} Returns the ErrorPage component
 */
export default function ErrorPage({
    statusCode = HTTP_NOT_FOUND,
    polopolyId,
}: ErrorPageProps) {
    const errorMessage = () => {
        if (statusCode === HTTP_NOT_FOUND) {
            return "We're sorry but the page you requested could not be found.";
        } else if (
            statusCode >= HTTP_INTERNAL_SERVER_ERROR &&
            statusCode <= HTTP_HTTP_VERSION_NOT_SUPPORTED
        ) {
            return "We're sorry but we've encountered an unexpected error.";
        } else {
            return "Sorry, but we've encountered an error.";
        }
    };

    const liteLink =
        (statusCode === HTTP_INTERNAL_SERVER_ERROR ||
            statusCode === HTTP_GATEWAY_TIMEOUT) &&
        polopolyId
            ? `https://www.cbc.ca/lite/story/${polopolyId}`
            : false;

    return (
        <div
            className={classNames(
                "errorPage",
                PAGE_COMPONENT_UNIVERSAL_CLASS_NAME
            )}
            data-testid="error-page"
            data-cy="error-page"
        >
            <div className="statusCode">
                <span className="digit" data-testid="status-code">
                    {statusCode}
                </span>
            </div>
            <div className="errorMessageText" data-testid="error-message-text">
                {errorMessage()}
                <br />
                Please try again from the <a href="/">home page</a>
                {liteLink && (
                    <span>
                        {", "}
                        <a href={liteLink}>our Lite version (low bandwidth)</a>
                        {","}
                    </span>
                )}{" "}
                or{" "}
                <a href="https://cbchelp.cbc.ca/hc/en-ca/requests/new?ticket_form_id=114094002513">
                    contact us
                </a>
                .
            </div>
        </div>
    );
}
